export const OFFER_PRICE_SSE_EVENTS = {
  STARTED: 'OFFER_PRICE_CALCULATION_STARTED',
  CALCULATED: 'OFFER_PRICE_CALCULATED',
  FAILED: 'OFFER_PRICE_CALCULATION_FAILED',
} as const;

export const OFFER_PRICE_SSE_EVENT_NAMES: string[] = [
  OFFER_PRICE_SSE_EVENTS.STARTED,
  OFFER_PRICE_SSE_EVENTS.CALCULATED,
  OFFER_PRICE_SSE_EVENTS.FAILED,
];

export interface OfferPriceSsePayload {
  offerId: number;
  message?: string;
}
